import Fragment from "./fragment";
import FragmentSummary from "./fragment-summary";

/**
 * Successful Deuce fragment for Indoor Football.
 * Indicates the kickoff went through the uprights - awards 2 points.
 */
export default class DeuceGood extends Fragment {
    constructor() {
        super();
        this.code = "DCEG";
    }

    summarize() {
        return new FragmentSummary(" was good");
    }

    updateSummaryContext(summaryContext) {
        summaryContext.eopPrinted = true;
    }

    getFragmentTeamId() {
        return this.kickedBy?.teamId;
    }

    toJSON() {
        return {
            ...super.toJSON()
        };
    }
}
